/**
 * QuestionHeader Component
 *
 * Handles the question header with dropdown functionality
 */

import * as React from 'react';
import { SectionTitle } from '../../../FormFieldWithOptions/presentation';
import { CustomFieldManagerProps, TagManagerProps } from '../../types';
import { CustomFieldSection } from './CustomFieldSection';
import { TagManagementSection } from './TagManagementSection';

interface QuestionHeaderProps {
	questionIndex: number;
	styles?: any[];
	onRemoveQuestion: () => void;
	isOptionField: boolean;
	hasTagPrefix: boolean;
	tagManagerProps?: TagManagerProps;
	onCreateTag: () => void;
	onEditTag: () => void;
	hasCustomField: boolean; // Whether the field type supports custom fields (determines if UI shows)
	hasExistingCustomField: boolean; // Whether a custom field is already configured (determines if edit mode shows)
	customFieldManagerProps?: CustomFieldManagerProps;
	onCreateCustomField?: () => void;
	onEditCustomField?: () => void;
	onValidationTrigger?: (questionIndex: number) => Promise<boolean>;
	onModalCreateTag: (handler: (() => void) | null) => void;
	onModalEditTag: (handler: (() => void) | null) => void;
	onModalCreateCustomField: (handler: (() => void) | null) => void;
	onModalEditCustomField: (handler: (() => void) | null) => void;
}

export const QuestionHeader: React.FC<QuestionHeaderProps> = React.memo(
	({
		questionIndex,
		styles = [],
		onRemoveQuestion,
		isOptionField,
		hasTagPrefix,
		tagManagerProps,
		onCreateTag,
		onEditTag,
		hasCustomField,
		hasExistingCustomField,
		customFieldManagerProps,
		onCreateCustomField,
		onEditCustomField,
		onValidationTrigger,
		onModalCreateTag,
		onModalEditTag,
		onModalCreateCustomField,
		onModalEditCustomField,
	}) => {
		return (
			<SectionTitle
				title={`Question ${questionIndex + 1}`}
				styles={styles}
				onRemoveQuestion={onRemoveQuestion}
				isOptionField={isOptionField}
				hasTagPrefix={hasTagPrefix}
				tagPrefix={
					<TagManagementSection
						tagManagerProps={tagManagerProps!}
						isOptionField={isOptionField}
						onValidationTrigger={onValidationTrigger}
						onModalCreateTag={onModalCreateTag}
						onModalEditTag={onModalEditTag}
					/>
				}
				onCreateTag={onCreateTag}
				onEditTag={onEditTag}
				hasCustomField={hasCustomField}
				hasExistingCustomField={hasExistingCustomField}
				customField={
					<CustomFieldSection
						customFieldManagerProps={customFieldManagerProps!}
						questionIndex={questionIndex}
						onValidationTrigger={onValidationTrigger}
						onModalCreateCustomField={onModalCreateCustomField}
						onModalEditCustomField={onModalEditCustomField}
					/>
				}
				onCreateCustomField={onCreateCustomField}
				onEditCustomField={onEditCustomField}
			/>
		);
	}
);

QuestionHeader.displayName = 'QuestionHeader';
